import { FeatureNameEnum } from '../features';
import { NavigationItemInterface } from '../interfaces';
import { RoutesEnum } from '../routes';

export const agendaNavigationItem: Readonly<NavigationItemInterface> = {
  name: FeatureNameEnum.Agenda,
  icon: 'calendar_month',
  route: `/${RoutesEnum.Agenda}`,
};
